export class StorageKeys {
    public static readonly CODE = 'COURSE_CODE';
    public static readonly COURSE_ID = 'COURSE_ID';
    public static readonly SELECTED_COURSE_TIME_SCHEDULE_ID = 'SELECTED_COURSE_TIME_SCHEDULE_ID';
    public static readonly LAST_BOOKING_STEP = 'LAST_BOOKING_STEP';
    public static readonly PERSON_IDENTIFICATION_VALIDATION = 'PERSON_IDENTIFICATION_VALIDATION';
    public static readonly INTAKE_REGISTRATION_SELF_ASSESSMENT = 'INTAKE_REGISTRATION_SELF_ASSESSMENT';
    public static readonly SHOPPING_CART_MODEL = 'SHOPPING_CART_MODEL';
    // onsite lector (DUO Weltweit vor Ort)
    public static readonly LECTOR_USERNAME = 'LECTOR_USERNAME';
    public static readonly LECTOR_PASSWORD = 'LECTOR_PASSWORD';
}
